import { useOutletContext } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { Features } from 'generated/featureDefinitions'
import { ContractsSettingPageQuery } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import { isFeatureAvailabilityEnabled } from 'modules/core/lib/isFeatureAvailabilityEnabled'

import ApprovalsBlock from 'modules/approvals/components/ApprovalsConfigurationBlock'
import ContractTaxonomies from 'modules/contracts_settings/components/ContractFields'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const AggrementApprovals = () => {
  const { data, loading, error } = useOutletContext<{
    data: ContractsSettingPageQuery
    loading: boolean
    error: unknown
  }>()

  const canEdit = !!data?.contracts._policies.contractEditContractsSettings.can
  const featureAvailabilities = data?.companies?.featureAvailabilitiesConnection?.nodes || []
  const hasCompensationsModule = isFeatureAvailabilityEnabled(
    featureAvailabilities,
    Features.compensations_management
  )

  const companyTemplatesTaxonomies = data?.contracts.contractTemplatesConnection.nodes || []

  return (
    <ResponsivePage.Body
      variant="wide"
      authorized={canEdit}
      showHeader={false}
      loading={loading}
      error={error}
    >
      <Box gap="s32" width="full" gapDivider>
        <ApprovalsBlock
          icon="document-approved"
          category="contracts"
          title={i18n.t('company_settings.general.employment_data.approvals.title')}
          description={i18n.t('company_settings.general.employment_data.approvals.description')}
          helpCenterUrlName="about-contracts-approval-system"
          noPadding
        />
        {!!companyTemplatesTaxonomies.length && (
          <ContractTaxonomies
            companyTemplatesTaxonomies={companyTemplatesTaxonomies}
            hasCompensationsModule={hasCompensationsModule}
          />
        )}
      </Box>
    </ResponsivePage.Body>
  )
}

export default AggrementApprovals
